import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { savedAddressList } from '../../../api/privateApis';
import useCountriesList from '../../../hooks/useCountriesList';
import {
  AddManualLegInitialValue,
  addressInitialValues,
  addressValidationInitialValues,
  addressValidationTrueValues,
} from '../../../initial-values';
import { RootState } from '../../../redux/rootReducer';
import {
  AddressDto,
  ManualLegDto,
  PostalValidationPayloadDto,
} from '../../../types';
import SearchDropdown from '../../global-components/searchDropdown';
import AddressForm from '../../shipment/route/addressForm';
import { isValidationValidated } from '../../../utils/helper';
import { validatePostalCode } from '../../../api/shipmentForms';
import X from '../../../assets/icons/new_icon/x.svg';
import { useSnackbar } from 'notistack';

interface Props {
  onClose: any;
  manualLegList: ManualLegDto[];
  setManualLegList: any;
}
const AddLegsModal = ({ onClose, manualLegList, setManualLegList }: Props) => {
  const countriesList = useCountriesList();
  const { provincesList } = useSelector(
    (state: RootState) => state.mainAppData
  );
  const { enqueueSnackbar } = useSnackbar();
  const [manualLegForm, setManualLegForm] = useState<ManualLegDto>(
    AddManualLegInitialValue
  );
  const [selectedLeg, setSelectedLeg] = useState('');
  const [validating, setValidating] = useState(false);
  const [loading, setLoading] = useState(false);
  // const [savedAddresses, setSavedAddresses] = useState<any>([]);
  const [savedOriginAddresses, setSavedOriginAddresses] = useState<any>([]);
  const [savedDestinationAddresses, setSavedDestinationAddresses] =
    useState<any>([]);
  const [originForm, setOriginForm] =
    useState<AddressDto>(addressInitialValues);
  const [destinationForm, setDestinationForm] =
    useState<AddressDto>(addressInitialValues);
  const [originFormValidations, setOriginFormValidations] = useState(
    addressValidationInitialValues
  );
  const [destinationFormValidations, setDestinationFormValidations] = useState(
    addressValidationInitialValues
  );
  const [originPostalCodeError, setOriginPostalCodeError] = useState(false);
  const [destinationPostalCodeError, setDestinationPostalCodeError] =
    useState(false);
  const [originPostalCodeValidated, setOriginPostalCodeValidated] =
    useState(false);
  const [destinationPostalCodeValidated, setDestinationPostalCodeValidated] =
    useState(false);
  function getAddressesAndContacts() {
    savedAddressList({ is_pagination: false })
      .then((response) => {
        if (!response?.data?.is_error) {
          let inputData = response?.data?.content;
          const transformedData = inputData.map((item: any) => {
            const transformedItem = {
              label: `${item.name} - ${item.address.address}, ${item.address.city}, ${item.address.province}, ${item.address.country}`,
              value: item.address,
            };

            if (item.is_origin) {
              // If item.is_origin is true, store it in setSavedOriginAddresses
              setSavedOriginAddresses((prevAddresses: any) => [
                ...prevAddresses,
                transformedItem,
              ]);
            }

            if (item.is_destination) {
              // If item.is_destination is true, store it in setSavedDestinationAddresses
              setSavedDestinationAddresses((prevAddresses: any) => [
                ...prevAddresses,
                transformedItem,
              ]);
            }
          });
        }
      })
      .catch((e) => {});
  }
  useEffect(() => {
    getAddressesAndContacts();
  }, []);
  function handleSave() {
    setValidating(true);
    if (originForm?.address === destinationForm?.address) {
      enqueueSnackbar('Origin and Destination addresses should be different.', {
        variant: 'error',
      });
      return;
    }
    if (
      !isValidationValidated(originFormValidations) ||
      !isValidationValidated(destinationFormValidations)
    )
      return;
    // if (selectedLeg === '') return;
    checkPostalCodeValidations();
  }
  function checkPostalCodeValidations() {
    setLoading(true);
    let payload: PostalValidationPayloadDto = {
      origin: {
        city: originForm.city,
        country: originForm.country,
        province: originForm.province,
        postal_code: originForm.postal_code,
      },
      destination: {
        city: destinationForm.city,
        country: destinationForm.country,
        province: destinationForm.province,
        postal_code: destinationForm.postal_code,
      },
    };

    validatePostalCode(payload.origin)
      .then((response) => {
        if (!response.data.is_error) {
          setOriginPostalCodeValidated(true);
        }
      })
      .catch((e) => {
        setLoading(false);
        setOriginPostalCodeError(true);
      });
    validatePostalCode(payload.destination)
      .then((response) => {
        if (!response.data.is_error) {
          setDestinationPostalCodeValidated(true);
        }
      })
      .catch((e) => {
        setDestinationPostalCodeError(true);
        setLoading(false);
      });
  }
  useEffect(() => {
    if (originPostalCodeValidated && destinationPostalCodeValidated) {
      setManualLegForm({
        ...manualLegForm,
        origin: originForm,
        destination: destinationForm,
        type: ``,
        postfix: ``,
        leg_added: 'yes',
        legValidations: {
          ...manualLegForm.legValidations,
          type: true,
        },
      });
    }
  }, [originPostalCodeValidated, destinationPostalCodeValidated]);
  useEffect(() => {
    if (manualLegForm.leg_added !== '') {
      setManualLegList([...manualLegList, manualLegForm]);
      onClose();
      setLoading(false);
    }
  }, [manualLegForm]);

  const handleClose = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div
      className='modal'
      id='legs_modal'
      style={{ display: 'block', backgroundColor: 'rgba(0, 0, 0, 0.5) ' }}
      tabIndex={-1}
      aria-labelledby='legs_modal_label'
      aria-hidden='true'
      onClick={handleClose}
    >
      {loading && (
        <div className='loader-container'>
          <div className='spinner'></div>
        </div>
      )}
      <div className='modal-dialog modal-xl'>
        <div className='modal-content'>
          <div className='modal-header d-flex w-100 justify-content-between px-3 py-2'>
            <h3 className='newubbemodalheading  mt-3'> Add Leg</h3>
            <img
              src={X}
              onClick={() => onClose()}
              style={{ cursor: 'pointer' }}
              alt=''
            />
          </div>

          <div className='modal-body'>
            {/* <div className='row mb-5'>
              <div className='col-4'>
                <label
                  htmlFor='leg_type'
                  className='form-label globalInputLabel'
                >
                  Type
                </label>
                <select
                  className={`form-select dropdown-style w-100 custom-select ${
                    selectedLeg
                      ? 'custom-select-selected'
                      : 'custom-select-notselected '
                  } '`}
                  id='leg_type'
                  aria-label='Leg'
                  value={selectedLeg}
                  onChange={(e) => {
                    setSelectedLeg(e.target.value);
                  }}
                >
                  <option value=''>Select Leg Type</option>
                  <option
                    value='P'
                    disabled={manualLegList.some((item) => item.type === 'P')}
                  >
                    Pickup
                  </option>
                  <option
                    value='M'
                    disabled={manualLegList.some((item) => item.type === 'M')}
                  >
                    Main
                  </option>
                  <option
                    value='D'
                    disabled={manualLegList.some((item) => item.type === 'D')}
                  >
                    Delivery
                  </option>
                </select>
                {validating && !selectedLeg && (
                  <div className='error_text'>{'Please provide a type.'}</div>
                )}
              </div>
              <div className='col-8'></div>
            </div> */}

            <div className='row mb-2 mt-4'>
              <div className='col-sm-12 col-md-6'>
                <div className='ubbe-card'>
                  <div className='ubbe-card-header'>
                    <h5 className='ps-3 mb-0 GlobalBoxHead'>Origin</h5>
                  </div>

                  <div className='card-body p-4'>
                    <div className='row '>
                      <div className='col-sm-12 col-md-12'>
                        <SearchDropdown
                          dontShowAlreadySelected={true}
                          id={'origin_saved_address'}
                          label='Select saved origin'
                          options={savedOriginAddresses && savedOriginAddresses}
                          onSelect={(item) => {
                            const { id, address_two, ...rest } = item?.value;
                            setOriginForm(rest);
                            setOriginFormValidations(
                              addressValidationTrueValues
                            );
                          }}
                        />
                      </div>
                    </div>
                    <div className='text-center pt-4 pb-2 divider'>or</div>

                    <AddressForm
                      countriesList={countriesList}
                      provincesList={provincesList}
                      formData={originForm}
                      validating={validating}
                      formValidation={originFormValidations}
                      setFormValidation={setOriginFormValidations}
                      postalCodeError={originPostalCodeError}
                      setFormData={setOriginForm}
                      origin={true}
                    />
                  </div>
                </div>
              </div>
              <div className='col-sm-12 col-md-6'>
                <div className='ubbe-card'>
                  <div className='ubbe-card-header'>
                    <h5 className='ps-3 mb-0 GlobalBoxHead'>Destination</h5>
                  </div>

                  <div className='card-body p-4'>
                    <div className='row '>
                      <div className='col-sm-12 col-md-12'>
                        <SearchDropdown
                          dontShowAlreadySelected={true}
                          label='Select saved destination'
                          id={'destination_saved_address'}
                          options={
                            savedDestinationAddresses &&
                            savedDestinationAddresses
                          }
                          onSelect={(item) => {
                            const { id, address_two, ...rest } = item?.value;
                            setDestinationForm(rest);
                            setDestinationFormValidations(
                              addressValidationTrueValues
                            );
                          }}
                        />
                      </div>
                    </div>
                    <div className='text-center pt-4 pb-2 divider'>or</div>

                    <AddressForm
                      countriesList={countriesList}
                      provincesList={provincesList}
                      formData={destinationForm}
                      validating={validating}
                      formValidation={destinationFormValidations}
                      setFormValidation={setDestinationFormValidations}
                      postalCodeError={destinationPostalCodeError}
                      setFormData={setDestinationForm}
                      sameAddressError={
                        originForm.address === destinationForm.address
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='row mt-3 mb-2'>
            <div className='col-sm-12'>
              <p
                className='btn ubbe-blue-bg p-2 w-100 rounded-3 text-light d-flex m-auto justify-content-center align-items-center mb-2'
                style={{ maxWidth: '108px', height: '48px' }}
                onClick={handleSave}
              >
                Save Leg
              </p>
              <u
                className='m-auto d-flex justify-content-center labelText'
                style={{ cursor: 'pointer' }}
                aria-label='Close'
                onClick={() => onClose()}
              >
                Cancel
              </u>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddLegsModal;
